export const environment = {
  production: true,
  envName: "production",
  apiUrl: "https://api.monscierge.com",
  authUrl: "https://auth.monscierge.com/auth/OAuth/token",
  mdmDeviceApiUrl: "https://mdm-api.monscierge.net",
  clientId: "0e7bfd31-c0e6-4c3a-be25-eaec1a02c7ac",
  clientSecret: "5C144F94-7C1F-4287-8700-F33F0ACCB77A",
  openAiApiKey: "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",
  enableDebugLogging: true,
};
